<app-search-input
    [form]="form"
    (focusin)="op.show($event)"
    placeholder="{{ label | translate }}"
    class="fulltext-search"
>
    <p-popover #op>
        <div class="flex gap">
            <p-listbox
                [options]="searchOptions"
                [(ngModel)]="selectedOptionSearch"
                (onChange)="listSearchChange($event)"
                emptyMessage="{{'database.persons.noResultsFound' | translate}}"
                optionLabel="createdAt"
                styleClass="h-full"
                scrollHeight="60vh"
            >
            </p-listbox>
            <div class="flex-column searchedText">
                <div class="flex-1 searchedText-content" [innerHTML]="selectedOptionSearchData | safeHtml"></div>
                @if (searchOptions.length) {
                    <p-divider></p-divider>
                }
                <div class="flex justify-content-end">
                    @if (selectedOptionSearchData) {
                        <app-button
                            (clickEvent)="accept();op.hide();"
                            label="fulltext.accept"
                            class="white-space-nowrap"
                        ></app-button>
                    }
                </div>
            </div>
        </div>
    </p-popover>
</app-search-input>
